import { Component, OnInit, OnDestroy, effect } from '@angular/core';
import { FormsModule, FormBuilder, FormGroup,  Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import { NgIf, NgFor, NgClass, } from '@angular/common';
import * as _ from 'lodash'
interface Field {
  field_id: string;
  text: string;
  interaction_type?: string;
  possible_values?: any[];
}

interface Group {
  id: string;
  name: string;
  groupType: 'question_group' | 'access_group';
  description?: string;
  fields: Field[];
  sameGroupExist?: boolean;
}

@Component({
    selector: 'app-litmus-intraction-groups',
    templateUrl: './litmus-intraction-groups.component.html',
    styleUrls: ['./litmus-intraction-groups.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor,NgClass,ReactiveFormsModule,FormsModule]
})
export class LitmusIntractionGroupsComponent implements OnInit, OnDestroy {
  // Data properties
  loading = true;
  searchText = '';
  groupsAvailable: Group[] = [];
  fields: Field[] = [];
  groupForm!: FormGroup;
  selectedGroup: Group | null = null;
  groupProperties: any = null;
  isEditing = false;
  isGroupSelectionDisabled = false;
  private destroy$ = new Subject<void>();
  showGroupModal:boolean = false;
  isUserHasWriteAccess: boolean = false;
  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private _conversations: ConversationService
  ) {
    this.initializeForm();

    effect(() => {
      this.isUserHasWriteAccess = this._conversations.isUserHasWriteAccess('MANAGE_CONVERSATION');
      const conversationObject = this._conversations.conversationObject();
      if (conversationObject) {
        this.fields = Helpers.deepClone(this._conversations.configuration.fields);
        this.groupProperties = Helpers.deepClone(this._conversations.sections);
        this.groupsAvailable = Helpers.deepClone(this.groupProperties);
        this.loading = false;
      }
    });
  }

  private initializeForm(): void {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
      groupType: [{ value: 'question_group', disabled: false }, Validators.required],
      fields: [[]]
    });

    // Subscribe to form changes for validation
    this.groupForm.get('name')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkSameGroupExist());
  }

  ngOnInit(): void {
    // this.loadData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openGroupModal(groupId?: string, groupType?: 'question_group' | 'access_group'): void {
    try {
      this.isEditing = !!groupId;
      if (groupId && groupType) {
        this.selectedGroup = this.groupsAvailable.find(g => g.id === groupId) || null;
        if (this.selectedGroup) {
          this.isGroupSelectionDisabled = true;
          this.groupForm.patchValue({
            name: this.selectedGroup.name,
            groupType: this.selectedGroup.groupType,
            fields: this.getFieldsByDynamicId(this.selectedGroup.groupType, this.selectedGroup.id)
          });
          // Disable the groupType control when editing
          this.groupForm.get('groupType')?.disable();
        }
      } else {
        this.isGroupSelectionDisabled = false;
        this.selectedGroup = null;
        this.groupForm.reset({
          groupType: 'question_group',
          fields: []
        });
        // Enable the groupType control for new groups
        this.groupForm.get('groupType')?.enable();
      }
      this.showGroupModal = true
      // this.modalService.open(content, {
      //   size: 'lg',
      //   backdrop: 'static',
      //   keyboard: false
      // });
    } catch (error) {
      console.error('Error opening modal:', error);
      // Handle error appropriately
    }
  }

  getFieldsByDynamicId(type, id) {
    var groupFields: any = [];
    this.fields.forEach((field: any) => {
      if (field && field.field_id) {
        if (field.dynamic_properties && field.dynamic_properties[type]) {
          var propAvailable = false;
          field.dynamic_properties[type].forEach((prop: any) => {
            if (prop && prop.id == id && !propAvailable) {
              propAvailable = true;
              groupFields.push({ field_id: field.field_id, text: field.text });
            }
          })
        }
      }
    })
    return groupFields;
  }

  saveGroup(event:any): void {
    if(event)event.preventDefault();
    try {
      if (this.groupForm.invalid) {
        this.markFormGroupTouched(this.groupForm);
        return;
      }

      const formValue = this.groupForm.value;
      const group: Group = {
        id: this.isEditing ? this.selectedGroup!.id : this.generateGroupId(formValue.name),
        name: formValue.name.trim(),
        groupType: formValue.groupType || this.selectedGroup?.groupType,
        fields: [...formValue.fields]
      };

      if (this.isEditing) {
        const index = this.groupsAvailable.findIndex(g => g.id === group.id);
        if (index !== -1) {
          this.groupsAvailable[index] = group;
        }
      } else {
        group.id = group.name.toLowerCase().replace(/ /g, '_');
        this.groupProperties.push(group);
        this.groupsAvailable.push(group);
      }

      var flds: any = [];
      group.fields.forEach(function (field) {
        flds.push(field.field_id);
      })
      this.updateFields(flds, group);

      this._conversations.saveConversation(false, this.isEditing ? "Section Updated" : "Section Saved").then(() => {
        this.showGroupModal = false;
        this.groupForm.reset();
        this.isGroupSelectionDisabled = false;
      });

    } catch (error) {
      console.error('Error saving group:', error);
      // Handle error appropriately
    }
  }

  updateFields(flds, group) {
    //TODO  = Check groupKey.,
    this._conversations.configuration.fields = _.map(this._conversations.configuration.fields ,(field) => {
      if (!field.dynamic_properties) {
        field.dynamic_properties = {};
      }
      if (!field.dynamic_properties[group.groupType]) {
        field.dynamic_properties[group.groupType] = [];
      }
      if (flds.indexOf(field.field_id) != -1) {
        var groupExist = _.find(field.dynamic_properties[group.groupType], { "id": group.id });
        if (groupExist) {
          field.dynamic_properties[group.groupType] = _.without(field.dynamic_properties[group.groupType], groupExist);
        }
        field.dynamic_properties[group.groupType].push({ id: group.id, name: group.name });
      } else {
        // group ref is deleted so delete ref from dynamic properties
        if ((field.dynamic_properties[group.groupType]).length) {
          field.dynamic_properties[group.groupType] = _.filter(field.dynamic_properties[group.groupType], function (g) {
            return g.id != group.id;
          })
        }
      }
      field.dynamic_properties[group.groupType] = _.uniq(field.dynamic_properties[group.groupType], 'id');

      _.each(field.dynamic_properties[group.groupType], function (f, idx) {
        if (f && f['fields'])
          delete f['fields'];
      })
      return field;
    })
  }

  removeGroup(groupId, groupType) {
    // Remove section from dynamic properties of fields
    this._conversations.configuration.fields = _.map(this._conversations.configuration.fields,  (field) =>{
        if (field.dynamic_properties) {
            field.dynamic_properties[groupType] = _.reject(field.dynamic_properties[groupType],  (group)=> {
                return group.id == groupId;
            });    
        }
        return field;
    });

    // Remove group from sections
    this._conversations.sections = _.reject(this._conversations.sections, function (group) {
        return group.id == groupId;
    });

    this._conversations.saveConversation(false, "Section Removed").then((response) => {
      // this.showEditModal = false;
    })
}

  private generateGroupId(name: string): string {
    return name.toLowerCase().replace(/ /g, '_');
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getGroupTypeLabel(type: 'question_group' | 'access_group'): string {
    return type === 'question_group' ? 'Interaction' : 'Visibility';
  }

  toggleField(field: Field, event: any): void {
    try {
      const fields = this.groupForm.get('fields')?.value || [];
      if (event.target.checked) {
        if (!this.isFieldAvailable(field.field_id)) {
          if (this.validateFieldAddition(field)) {
            fields.push({ ...field }); // Create a new object to avoid reference issues
          } else {
            event.target.checked = false;
            return;
          }
        }
      } else {
        const index = fields.findIndex((f: Field) => f.field_id === field.field_id);
        if (index !== -1) {
          fields.splice(index, 1);
        }
      }
      this.groupForm.patchValue({ fields });
    } catch (error) {
      console.error('Error toggling field:', error);
      event.target.checked = false;
      // Handle error appropriately
    }
  }

  isFieldAvailable(fieldId: string): boolean {
    const fields = this.groupForm.get('fields')?.value || [];
    return fields.some((f: Field) => f.field_id === fieldId);
  }

  private validateFieldAddition(newField: Field): boolean {
    try {
      const currentFields = this.groupForm.get('fields')?.value || [];
      const groupType = this.groupForm.get('groupType')?.value;

      if (groupType === 'access_group') {
        if (newField.field_id === 'primary_rating' || newField.field_id === 'comments') {
          alert('Error: Visibility groups cannot contain rating or comment fields.');
          return false;
        }
      } else if (groupType === 'question_group') {
        if (currentFields.length > 0) {
          const firstField = currentFields[0];
          if (firstField.possible_values && newField.possible_values) {
            if (firstField.possible_values.length !== newField.possible_values.length) {
              alert('Error: Group can contain Interactions only with the same scale.');
              return false;
            }
          }
        }
      }

      return true;
    } catch (error) {
      console.error('Error validating field addition:', error);
      return false;
    }
  }

  filterFieldsOnGroupToggle(field: Field): boolean {
    try {
      const groupType = this.groupForm.get('groupType')?.value;

      if(field.interaction_type != "label"){
        if (groupType === 'access_group') { 
          return !(field.field_id === 'primary_rating' || field.field_id === 'comments');
        } else if (groupType === 'question_group') {
          return field.interaction_type === 'rating' || field.field_id === 'primary_rating' || field.field_id === 'comments';
        }
      }
      return false;
    } catch (error) {
      console.error('Error filtering fields:', error);
      return false;
    }
  }

  resetFieldsOnToggleGroup(): void {
    try {
      if (!this.isEditing) {
        this.groupForm.patchValue({ fields: [] });
      }
      this.checkSameGroupExist();
    } catch (error) {
      console.error('Error resetting fields:', error);
      // Handle error appropriately
    }
  }

  checkSameGroupExist(): void {
    try {
      const formValue = this.groupForm.value;
      const existingGroup = this.groupsAvailable.find(g =>
        g.name.toLowerCase().trim().replace(/ /g, '_') === formValue.name?.toLowerCase().trim().replace(/ /g, '_')
      );

      this.groupForm.get('name')?.setErrors(
        existingGroup ? { groupExists: true } : null
      );
    } catch (error) {
      console.error('Error checking group existence:', error);
      // Handle error appropriately
    }
  }

  get filteredGroups(): Group[] {
    try {
      if (!this.searchText || this.searchText.trim() === '') {
        return this.groupsAvailable;
      } 

      const searchTerm = this.searchText.toLowerCase().trim();
      return this.groupsAvailable.filter(group =>
        group.name.toLowerCase().includes(searchTerm) ||
        this.getGroupTypeLabel(group.groupType).toLowerCase().includes(searchTerm)
      );
    } catch (error) {
      console.error('Error filtering groups:', error);
      return this.groupsAvailable;
    }
  }

  // Add public method to dismiss modal
  dismissModal(): void {
    this.showGroupModal = false;
    // this.modalService.dismissAll();
    this.groupForm.reset();
    this.isGroupSelectionDisabled = false;
  }
}
